import Loadable from '../components/loadable';

const Banner = Loadable({
  loader: () => import('../components/banner'),
});

angular.module('gym').value('Banner', Banner);
